import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { AppsService } from '@app/shared/services/apps/apps.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-autohost',
  templateUrl: './autohost.component.html',
  styleUrls: ['./autohost.component.scss'],
})
export class AutohostComponent implements OnInit {
  saveStatus: number;
  loading = false;
  autohostEnabled;
  apiKeyDeleting = false;
  showInput = true;
  apiKey = '';
  learnMoreUrl = `https://my.hospitable.com/support-documentation/article/6049082-how-do-i-integrate-with-autohost`;
  constructor(
    private authService: AuthenticationService,
    private appsService: AppsService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit(): void {
    this.getApiKey();
  }

  getApiKey() {
    this.appsService.getAutohostEnabled(this.authService.getUserDetails(true).team.id).subscribe((res) => {
      this.apiKey = res.api_key;
      this.autohostEnabled = res.status;
      if (this.apiKey !== '') {
        this.showInput = false;
      } else {
        this.showInput = false;
      }
    });
  }

  removeApiKey() {
    this.apiKeyDeleting = true;
    this.appsService.removeAutohostApiKey(this.authService.getUserDetails().team.id).subscribe(
      (res) => {
        this.apiKey = '';
        this.apiKeyDeleting = false;
        this.autohostEnabled = false;
        this.showInput = true;
      },
      (error) => {
        this.apiKeyDeleting = true;
      }
    );
  }

  saveApiKey() {
    if (this.apiKey.length === 0) {
      this.showToast(`API key can not be empty`);
    }

    if (this.apiKey.length > 0) {
      this.saveStatus = 1;
      this.appsService.setAutohostApiKey(this.authService.getUserDetails().team.id, this.apiKey).subscribe(
        (res) => {
          this.saveStatus = 2;
          this.getApiKey();
        },
        (error) => {
          this.saveStatus = -1;
        }
      );
    }
  }

  showToast(message: string) {
    this.toast.open(message, 'Dismiss', NotificationType.Error);
  }

  learnMore() {
    window.open(this.learnMoreUrl, '_blank');
  }
}
